/* =====================================================================
 * errorReporter — thin telemetry seam so shared boundaries don't depend
 * on a specific vendor (Sentry, Datadog, on-prem syslog, …).
 *
 * Hosts register an adapter at bootstrap (B2C wires up `@sentry/react`;
 * on-prem B2B typically wires a no-op or an internal logger). If no
 * adapter is registered, errors fall through to console.error so dev
 * environments still surface them.
 * ===================================================================== */

export interface ErrorReporterOptions {
  tags?: Record<string, string | number | boolean | null | undefined>;
  extra?: Record<string, unknown>;
}

export interface ErrorReporter {
  captureException(error: unknown, options?: ErrorReporterOptions): void;
}

let reporter: ErrorReporter | null = null;

export function setErrorReporter(impl: ErrorReporter | null): void {
  reporter = impl;
}

export function getErrorReporter(): ErrorReporter | null {
  return reporter;
}

export function reportError(error: unknown, options?: ErrorReporterOptions): void {
  if (reporter) {
    try {
      reporter.captureException(error, options);
      return;
    } catch {
      // fall through to console
    }
  }
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error('[workspace-ui/errorReporter]', error, options);
  }
}
